import { motion, useMotionValue, useScroll, useSpring, useTransform } from "framer-motion";
import { EASE } from "../../config";

const Layer = ({ mx, my, depth, className, clip, delay, color }) => {
  const x = useTransform(mx, [-0.5, 0.5], [-depth, depth]);
  const y = useTransform(my, [-0.5, 0.5], [-depth, depth]);
  return (
    <motion.div className={`absolute ${className}`} style={{ x, y }}>
      <motion.div
        className="h-full w-full"
        style={{ background: color }}
        initial={{ clipPath: "inset(100% 0 0 0)" }}
        animate={{ clipPath: clip }}
        transition={{ duration: 1.4, ease: EASE, delay }}
      />
    </motion.div>
  );
};

export const HeroBlocks = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const smx = useSpring(mx, { stiffness: 60, damping: 18 });
  const smy = useSpring(my, { stiffness: 60, damping: 18 });
  const rotY = useTransform(smx, [-0.5, 0.5], [-10, 10]);
  const rotX = useTransform(smy, [-0.5, 0.5], [8, -8]);
  const { scrollY } = useScroll();
  const lift = useTransform(scrollY, [0, 700], [0, -90]);

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const onLeave = () => { mx.set(0); my.set(0); };

  return (
    <div className="relative h-full w-full [perspective:1200px]" onMouseMove={onMove} onMouseLeave={onLeave} data-testid="hero-blocks">
      <motion.div className="relative h-full w-full [transform-style:preserve-3d]" style={{ rotateX: rotX, rotateY: rotY, y: lift }}>
        <Layer mx={smx} my={smy} depth={10} color="#005F60" className="left-[8%] top-[4%] h-[78%] w-[62%]" clip="polygon(0 0, 100% 0, 100% 100%, 0 100%)" delay={0.3} />
        <Layer mx={smx} my={smy} depth={26} color="#FF682F" className="left-[26%] top-[30%] h-[62%] w-[70%]" clip="polygon(0 38%, 100% 0, 100% 62%, 0 100%)" delay={0.55} />
        <Layer mx={smx} my={smy} depth={42} color="#FFCC00" className="right-[4%] top-0 h-[34%] w-[30%]" clip="polygon(0 0, 100% 0, 100% 100%, 0 100%)" delay={0.8} />
        <motion.p
          className="absolute bottom-[2%] left-[8%] text-[11px] uppercase tracking-[0.28em] text-[#4A525A]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.4, duration: 1 }}
        >
          08°50′S · Luanda — 23°33′S · São Paulo
        </motion.p>
      </motion.div>
    </div>
  );
};
